import React, { useEffect } from 'react'
import { FullPage, TextHeader, Select } from '@wallyhealth/web-core'
import styles from './index.module.css'
import intelService from 'services/intelService'
import SlotsWrapper from 'components/schedule/SlotsWrapper'

const toSelectLocation = (it) => ({
  id: it.id,
  label: it.name
})

const VIEW_NAME = 'BookAndJoinTimePage'

const DEFAULT_TITLE = "Let's find a time that works for you."

const BookPage = ({ title = DEFAULT_TITLE, slots, selectedSlot, onSlotSelected, locations = [], locationId, onLocationIdSelected }) => {
  useEffect(() => {
    intelService.recordView({ viewName: VIEW_NAME })
  }, [])

  return (
    <FullPage bodyClassName={styles.container}>
      <TextHeader
        title={title}
        titleClassName={styles.title}
        className={styles.header}
      />
       {(locations.length > 1) &&
        <Select
          value={locationId}
          items={locations.map(toSelectLocation)}
          onSelected={onLocationIdSelected}
          className={styles.locations}
        />
      }
      <SlotsWrapper
        className={styles.slots}
        slots={slots}
        onSlotSelected={onSlotSelected}
        selectedTimeSlot={selectedSlot}
      />
    </FullPage>
  )
}

export default BookPage
